import { ReactNode, useEffect, useState } from 'react'
import LoadingSpinner from '../../Components/LoadingSpinner'
import useBrief from '../../Hooks/Brief/useBrief'
import { showBizLayout as shouldShowBizLayout } from '../../Logic/Form/Sequences/Biz/isBizBrief'
import BriefContext from './briefContext'
import './BriefProvider.less'

interface BriefProviderProps {
  children: ReactNode
}

const BriefProvider = ({ children }: BriefProviderProps): JSX.Element => {
  const briefState = useBrief()
  const [showBizLayout, setShowBizLayout] = useState(shouldShowBizLayout(briefState.brief))

  useEffect(() => {
    if (briefState.loading) return

    setShowBizLayout(shouldShowBizLayout(briefState.brief))
  }, [briefState.loading])

  const globalBriefState = { ...briefState, showBizLayout, setShowBizLayout }
  // the children render the loading state in the 'submitting' case
  const hideChildren = briefState.loading && !briefState.submitting

  return (
    <BriefContext.Provider value={globalBriefState}>
      {hideChildren && <LoadingSpinner fullPage={true} />}

      <div
        className={`brief-builder-provider
        ${hideChildren ? 'hidden' : 'loaded'}
        ${showBizLayout ? 'biz-flow' : 'lf-flow'}`}>
        {children}
      </div>
    </BriefContext.Provider>
  )
}
export default BriefProvider
